import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { Route } from 'react-router';

import PageProductContainer from '@mssgme/app/components/Product/PageProductContainer';
import { CardProductsPage } from '../Elements';
import { Card } from '../../UI';

export function CardRoutes({ data, widgetMode, paths }) {
    const [lastCollectionSlug, setLastCollectionSlug] = useState(false);
    const [firstLoad, setFirstLoad] = useState(true);

    return (
        <>
            <Route
                path={paths.home}
                render={(props) => (
                    <Card
                        {...props}
                        data={data}
                        previewMode
                        widgetMode={widgetMode}
                        firstLoad={firstLoad}
                        setFirstLoad={setFirstLoad}
                    />
                )}
            />
            <Route
                path={paths.product}
                render={(props) => (
                    <PageProductContainer
                        {...props}
                        card={data}
                        firstLoad={firstLoad}
                        setFirstLoad={setFirstLoad}
                        setLastCollectionSlug={setLastCollectionSlug}
                        lastCollectionSlug={lastCollectionSlug}
                    />
                )}
            />
            <Route
                path={[paths.collection, paths.product]}
                render={({ match }) => {
                    if (!match.params.collectionSlug && !lastCollectionSlug) {
                        return null;
                    }

                    return (
                        <CardProductsPage
                            collectionSlug={match.params.collectionSlug || lastCollectionSlug}
                            card={data}
                            setLastCollectionSlug={setLastCollectionSlug}
                            firstLoad={firstLoad}
                            setFirstLoad={setFirstLoad}
                        />
                    );
                }}
            />
        </>
    );
}

CardRoutes.propTypes = {
    data: PropTypes.object.isRequired,
    paths: PropTypes.object.isRequired,
    widgetMode: PropTypes.bool,
};

CardRoutes.defaultProps = {
    widgetMode: false,
};
